import { StyleSheet, css } from 'aphrodite';
import { PropTypes } from 'prop-types';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Theme } from '../../config/theme';

import { updateAppState } from '../../actions/applicationState';
import { search } from '../../actions/search';

import ContentContainer from '../ContentContainer';
import DogCard from '../DogCard';

let styles;

export default class HomepageFeaturedDogs extends Component {
  constructor(props) {
    super(props);

    this.handleSearch = this.performSearch.bind(this);
    this.handleInterests = this.toggleInterest.bind(this);
    this.handleNeeds = this.toggleNeed.bind(this);
    this.handleCity = this.setCity.bind(this);
    this.handleDistrict = this.setDistrict.bind(this);
    this.handleBreeds = this.setBreeds.bind(this);
    this.toggleMobFilter = this.toggleMobFilter.bind(this);

    this.state = {
      results: [],
      interests: [],
      needs: [],
      city: null,
      district: null,
      breeds: null,
      filterVisibleMob: false,
    };
  }

  componentDidMount() {
    // Skip API calls during react-snap pre-rendering
    if (navigator.userAgent === 'ReactSnap') {
      return;
    }

    this.doSearch(false);
  }

  setCity(name, city) {
    this.setState({
      city: city ? city.value : null,
    });
  }

  setDistrict(name, district) {
    this.setState({
      district: district ? district.value : null,
    });
  }

  setBreeds(name, breeds) {
    this.setState({
      breeds: breeds.value,
    });
  }

  toggleMobFilter() {
    this.setState({
      filterVisibleMob: !this.state.filterVisibleMob,
    });
  }

  toggleInterest(selected, interestID) {
    if (selected) {
      this.setState({
        interests: [].concat(this.state.interests, [interestID]),
      });
    } else {
      this.setState({
        interests: this.state.interests.filter(interest => interest !== interestID),
      });
    }
  }

  toggleNeed(selected, needID) {
    if (selected) {
      this.setState({
        needs: [].concat(this.state.needs, [needID]),
      });
    } else {
      this.setState({
        needs: this.state.needs.filter(interest => interest !== needID),
      });
    }
  }

  doSearch(showLoading = true) {
    this.performSearch(
      this.state.interests,
      this.state.city,
      this.state.district,
      this.state.breeds,
      this.state.needs,
      showLoading,
    );
  }

  performSearch(interests, city, district, breeds, needs, showLoading = true) {
    const cityQuery = city;
    const districtQuery = district;
    const breedsQuery = typeof breeds === 'number' ? [breeds] : null;
    const interestsQuery = interests && interests.length ? interests : null;
    const needsQuery = needs && needs.length ? needs : null;

    this.setState({
      filterVisibleMob: false,
    });

    this.props
      .dispatch(
        updateAppState({
          loading: showLoading,
          loading_text: 'Searching',
        }),
      )
      .then(() => {
        this.props
          .dispatch(
            search(
              interestsQuery,
              cityQuery,
              districtQuery,
              breedsQuery,
              needsQuery,
              1,
              'home/search',
            ),
          )
          .then(
            results => {
              this.setState({
                results,
                count: results.count,
                page: results.page,
              });

              this.props.dispatch(
                updateAppState({
                  loading: false,
                  loading_text: false,
                }),
              );
            },
            err => {
              console.log(err); // eslint-disable-line

              this.props.dispatch(
                updateAppState({
                  loading: false,
                  loading_text: false,
                }),
              );
            },
          );
      });
  }

  render() {
    return (
      <div className={css(styles.container)}>
        <ContentContainer>
          <div className={css(styles.cards)}>
            {this.state.results.length
              ? this.state.results.map(dog => (
                  <DogCard
                    key={dog.dog_id}
                    id={null}
                    signup
                    image={dog.image_url}
                    name={dog.name}
                    breed={dog.breed}
                    summary={dog.bio}
                    interests={dog.interests}
                    needs={dog.needs}
                    suburb={dog.suburb}
                  />
                ))
              : false}
          </div>
          <Link to="/join" className={css(styles.more)}>
            {Theme.isMobile ? 'Join to view more' : 'Join us to view more pooches'}
          </Link>
        </ContentContainer>
      </div>
    );
  }
}

HomepageFeaturedDogs.propTypes = {
  dispatch: PropTypes.func.isRequired,
  // appdata: PropTypes.object.isRequired,
};

styles = StyleSheet.create({
  container: {
    padding: '0 0 40px',
    backgroundColor: '#fff',
  },
  cards: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    margin: '0 -15px',

    [Theme.mobile_query]: {
      padding: '0 20px',
    },
  },
  more: {
    display: 'block',
    fontFamily: Theme.font_family_secondary,
    fontWeight: Theme.font_weight_secondary,
    fontSize: 15,
    textAlign: 'center',
    textTransform: 'uppercase',
    letterSpacing: 2,

    '@media screen and (min-width: 601px)': {
      marginTop: 9,
      color: Theme.primary,
    },

    [Theme.mobile_query]: {
      height: 50,
      margin: '0 20px',
      lineHeight: '50px',
      color: Theme.white,
      border: 0,
      borderRadius: 5,
      backgroundColor: Theme.primary,
      cursor: 'pointer',
      outline: 'none',
    },
  },
  mob_find: {
    display: 'block',
    width: '100vw',
    height: 50,
    margin: '0 -15px 30px',
    textTransform: 'uppercase',
    fontSize: 15,
    fontWeight: 900,
    lineHeight: 1.73,
    letterSpacing: 2,
    textAlign: 'center',
    color: Theme.primary,
    border: 0,
    borderTop: '1px solid #cecece',
    borderBottom: '1px solid #cecece',
    backgroundColor: Theme.white,
    cursor: 'pointer',
    outline: 'none',
    transition: 'background-color 300ms',
  },
});



// WEBPACK FOOTER //
// ./src/components/HomepageFeaturedDogs/index.js